/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import Paginate  from './components/Paginate'
import BadgeClipboard  from './components/badge/Clipboard'
import BadgeEnabled  from './components/badge/Enabled'
import SaveButton  from './components/buttons/SaveButton'
import EditButton  from './components/buttons/EditButton'
import DeleteButton  from './components/buttons/DeleteButton'
import CancelButton  from './components/buttons/CancelButton'
import FileInput from '@/components/form-inputs/FileInput'
import ValidationError from '@/components/form-inputs/ValidationError'
import Spinner from '@/components/Spinner'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(Paginate.name, Paginate)
Vue.component(BadgeClipboard.name, BadgeClipboard)
Vue.component(BadgeEnabled.name, BadgeEnabled)
Vue.component(SaveButton.name, SaveButton)
Vue.component(EditButton.name, EditButton)
Vue.component(DeleteButton.name, DeleteButton)
Vue.component(CancelButton.name, CancelButton)
Vue.component(FileInput.name, FileInput)
Vue.component(ValidationError.name, ValidationError)
Vue.component(Spinner.name, Spinner)


// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component('vSelect', vSelect)
